/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRename = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 2v2a1.999 1.999 0 0 0-1.995 1.85L18 6v2h4v8h-4v2a2 2 0 0 0 1.85 1.995L20 20v2a3.99 3.99 0 0 1-3-1.354 3.985 3.985 0 0 1-2.8 1.35L14 22v-2a1.999 1.999 0 0 0 1.995-1.85L16 18V6a1.999 1.999 0 0 0-1.85-1.995L14 4V2a3.99 3.99 0 0 1 3 1.354 3.985 3.985 0 0 1 2.8-1.35zm-6 6v2H4v4h10v2H2V8zm6 2h-2v4h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRename as Rename };
